export default "__VITE_ASSET__DKnf3PV5__"